// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__21gD2","label":"SetPasswdForm_label__1M7ue"};